import React, {Component} from "react";
import SimpleDDL from "../../../modules/SimpleDDL";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Container from "../../../modules/commons/Container";
import Api from "../../../Services/Api";
import {mapToObjectDDL} from "../../common/mapper";
import EkspedisiContent from "./common/ekspedisiContent";
import {CONFIG} from "./config";

class Ekspedisi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataCabang: [],
            search: {
                kodeCabang: null,
            },
        }
    }

    componentDidMount = async () => {
        await this.fetchDataCabang();
    }

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    fetchDataCabang = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData.map(data => mapToObjectDDL(data.namaDealer, data.kodeCabang)),
                        search: {
                            ...prevValue.search,
                            kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                        },
                    }));
                }
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    render() {
        return (
            <Container>
                <SimpleDDL
                    id="select_options_nama_cabang"
                    box="search"
                    name="kodeCabang"
                    containerclassname="width width-350px"
                    placeholder="Nama Cabang"
                    menuPosition="fixed"
                    options={this.state.dataCabang}
                    value={this.state.search.kodeCabang}
                    onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                />
                <Tabs>
                    <TabList>
                        <Tab id="button_navigate_belum_ekspedisi">Belum Ekspedisi</Tab>
                        <Tab id="button_navigate_sudah_ekspedisi">Sudah Ekspedisi - Lengkap</Tab>
                        <Tab id="button_navigate_sudah_ekspedisi">Sudah Ekspedisi - Menyusul</Tab>
                    </TabList>
                    <TabPanel>
                        <EkspedisiContent
                            {...this.props}
                            tab={CONFIG.TAB.BELUM_EKSPEDISI}
                            selectedCabang={this.state.search.kodeCabang}
                        />
                    </TabPanel>
                    <TabPanel>
                        <EkspedisiContent
                            {...this.props}
                            tab={CONFIG.TAB.SUDAH_EKSPEDISI}
                            selectedCabang={this.state.search.kodeCabang}
                        />
                    </TabPanel>
                    <TabPanel>
                        <EkspedisiContent
                            {...this.props}
                            isMenyusul={true}
                            tab={CONFIG.TAB.SUDAH_EKSPEDISI}
                            selectedCabang={this.state.search.kodeCabang}
                        />
                    </TabPanel>
                </Tabs>
            </Container>
        );
    }
}

export default Ekspedisi;